import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useEffect, useState } from "react";
import { List } from "react-virtualized";
import OcRow1 from "./oc-view1/oc-row";
import OCRow2 from "./oc-view2/oc-row2";
const OCWrapper = ({ optionsChain, id, symbol, isHoverEnabled = true, expiry, toggled, position, selectedOptionType, lotSize, activeStrike, spotScripDetails, }) => {
    const getStrikeChainList = () => {
        let localChain = Object.keys(optionsChain || {});
        localChain = localChain.sort((singleElement1, singleElement2) => {
            return Number(singleElement1) - Number(singleElement2);
        });
        return localChain;
    };
    const [chain, setChain] = useState(getStrikeChainList());
    const [scrollToIndex, setScrollToIndex] = useState(0);
    useEffect(() => {
        // const scrollTo = cutOffPriceIndex - 5;
        // setScrollToIndex(scrollTo);
        const chain = getStrikeChainList();
        setChain(chain);
        const scrollIndex = chain.findIndex((singleElement) => {
            return singleElement == activeStrike + "";
        });
        if (scrollIndex > 0) {
            const scrollTo = scrollIndex - 4;
            setScrollToIndex(scrollTo);
        }
        else {
            setScrollToIndex(0);
        }
    }, [selectedOptionType]);
    const renderRow = (data) => {
        const { index, key, style } = data;
        if (chain[index] && Object.keys(optionsChain).length > 0) {
            try {
                const { PE: { OI: putOI = 0, OI_CHANGE: putOIPerc, LTP: putLTP = 0, PREVIOUS_CLOSE: prevPutClose = 0, PREV_OI: prevOIPut = 0, MAX_OI: putMaxOI = 0, EXCH: putExch = "", EXCH_TYPE: putExchType = "", NAME: putName = "", SCRIPT_CODE: putScripCode = 0, GREEKS_DATA: putGreeksData = {}, }, CE: { OI: callOI = 0, OI_CHANGE: callOIPerc, LTP: callLTP = 0, PREVIOUS_CLOSE: prevCallClose = 0, PREV_OI: prevOICall = 0, MAX_OI: callMaxOI = 0, EXCH: callExch = "", EXCH_TYPE: callExchType = "", NAME: callName = "", SCRIPT_CODE: callScripCode = 0, GREEKS_DATA: callGreeksData = {}, }, } = (optionsChain || {})[chain[index]] || {};
                const priceChangeCall = callLTP - prevCallClose;
                const priceChangePut = putLTP - prevPutClose;
                const callOIChange = callOI - prevOICall;
                const putOIChange = putOI - prevOIPut;
                let callLTPPerc = Math.abs(100 - (callLTP * 100) / prevCallClose || 0);
                if (callLTP < prevCallClose)
                    callLTPPerc = callLTPPerc * -1;
                let putLTPPerc = Math.abs(100 - (putLTP * 100) / prevPutClose || 0);
                if (putLTP < prevPutClose)
                    putLTPPerc = putLTPPerc * -1;
                const callTrend = getTagFromData(priceChangeCall, callOIChange);
                const putTrend = getTagFromData(priceChangePut, putOIChange);
                const callTrendColor = getColorFromTag(callTrend);
                const putTrendColor = getColorFromTag(putTrend);
                const rowProps = {
                    key: chain[index],
                    strike: chain[index],
                    callOI: callOI,
                    putOI: putOI,
                    callLTP: callLTP,
                    putLTP: putLTP,
                    callLTPPerc: callLTPPerc,
                    putLTPPerc: putLTPPerc,
                    callTrendColor: callTrendColor,
                    putTrendColor: putTrendColor,
                    callTrend: callTrend,
                    putTrend: putTrend,
                    callOIPerc: callOIPerc,
                    putOIPerc: putOIPerc,
                    callMaxOI: callMaxOI,
                    putMaxOI: putMaxOI,
                    prevPutClose: prevPutClose,
                    prevCallClose: prevCallClose,
                    putExch: putExch,
                    putExchType: putExchType,
                    putName: putName,
                    putScripCode: putScripCode,
                    prevOICall: prevOICall,
                    prevOIPut: prevOIPut,
                    callExch: callExch,
                    callExchType: callExchType,
                    callName: callName,
                    callScripCode: callScripCode,
                    i: index,
                    isHoverEnabled: isHoverEnabled,
                    symbol: symbol,
                    expiry: expiry,
                    isChecked: false,
                    position: position,
                    selectedOptionType: selectedOptionType,
                    callGreeksData: callGreeksData,
                    putGreeksData: putGreeksData,
                    lotSize: lotSize,
                    activeStrike: activeStrike,
                    spotScripDetails: spotScripDetails,
                };
                return (_jsx("div", Object.assign({ style: style }, { children: toggled ? _jsx(OCRow2, Object.assign({}, rowProps)) : _jsx(OcRow1, Object.assign({}, rowProps)) }), key));
            }
            catch (err) {
                console.error("Error");
                return _jsx(_Fragment, {});
            }
        }
        else {
            return _jsx(_Fragment, {});
        }
    };
    return (_jsx(List, { style: { width: "100%" }, width: 500, height: 400, rowHeight: selectedOptionType == "Greeks" ? 127 : 40, rowRenderer: renderRow, rowCount: chain.length, scrollToAlignment: "start", scrollToIndex: scrollToIndex }));
};
const getTagFromData = (priceChange, oiChange) => {
    if (priceChange >= 0 && oiChange >= 0) {
        return "LB";
    }
    if (priceChange < 0 && oiChange >= 0) {
        return "SB";
    }
    if (priceChange < 0 && oiChange < 0) {
        return "LU";
    }
    if (priceChange >= 0 && oiChange < 0) {
        return "SC";
    }
    return "";
};
const getColorFromTag = (tag) => {
    if (tag == "SB") {
        return "rgba(229, 69, 93, 0.55)";
    }
    if (tag == "LB") {
        return "rgba(0, 178, 158, 0.55)";
    }
    if (tag == "LU") {
        return "rgba(229, 69, 93, 0.25";
    }
    if (tag == "SC") {
        return " rgba(0, 178, 158, 0.25)";
    }
    return "";
};
export default memo(OCWrapper);
